import axios from 'axios';

/** Supply a real CEO overview API URL. This module does not assume a backend route. */
export function createCEOOverviewLoader({ endpoint, sessionToken }) {
  if (!endpoint) return null;
  return async ({ period, signal }) => {
    const response = await axios.get(endpoint, {
      params: { period },
      signal,
      timeout: 30000,
      headers: sessionToken ? { Authorization: `Bearer ${sessionToken}` } : undefined,
    });
    const payload = response.data?.data ?? response.data;
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      throw new Error('The overview service returned an invalid response.');
    }
    return payload;
  };
}
